'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Snackbar = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Snackbar, _Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.getBarStyle = function () {
      var isActive = _this.props.isActive;


      var activeStateStyle = void 0;
      var defaultStateStyle = void 0;

      var baseStyle = {
        defaultState: {
          position: 'fixed',
          bottom: '2rem',
          left: '-100%',
          width: 'auto',
          padding: '1rem',
          margin: 0,
          color: '#fafafa',
          font: '1rem normal Roboto, sans-serif',
          borderRadius: '5px',
          background: '#212121',
          borderSizing: 'border-box',
          boxShadow: '0 0 1px 1px rgba(10, 10, 11, .125)',
          cursor: 'default',
          WebKittransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
          MozTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
          msTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
          OTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
          transition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',

          // Trigger GPU acceleration
          WebkitTransform: 'translatez(0)',
          MozTransform: 'translatez(0)',
          msTransform: 'translatez(0)',
          OTransform: 'translatez(0)',
          transform: 'translatez(0)'
        },
        activeState: {
          left: '1rem'
        }
      };

      /**
       * If styles is set to false, then return nothing.
       */
      if (_this.props.style === false) {
        return {};
      }

      /**
       * If `this.props.styles.active` exists (which means
       * custom active styles should be used, override the
       * default active styles with those from the prop.
       */
      if (_this.props.style && _this.props.style.active) {
        activeStateStyle = (0, _assign2.default)(baseStyle.activeState, _this.props.style.active);
      } else {
        activeStateStyle = baseStyle.activeState;
      }

      /**
       * If `this.props.styles.bar` exists (which means custom
       * styles should be applied to the bar) combine those
       * styles with the existing base style.
       */
      if (_this.props.style && _this.props.style.bar) {
        defaultStateStyle = (0, _assign2.default)(baseStyle.defaultState, _this.props.style.bar);
      } else {
        defaultStateStyle = baseStyle.defaultState;
      }

      return isActive ? (0, _assign2.default)(defaultStateStyle, activeStateStyle) : defaultStateStyle;
    }, _this.getActionStyle = function () {
      var baseStyle = {
        padding: '0.125rem',
        marginLeft: '1rem',
        color: '#f44336',
        font: '.75rem normal Roboto, sans-serif',
        lineHeight: '1rem',
        letterSpacing: '.125ex',
        textTransform: 'uppercase',
        borderRadius: '5px',
        cursor: 'pointer'
      };

      if (_this.props.style === false) {
        return {};
      }

      if (_this.props.style && _this.props.style.action) {
        return (0, _assign2.default)(baseStyle, _this.props.style.action);
      }

      return baseStyle;
    }, _this.handleClick = function (event) {
      event.preventDefault();

      if (_this.props.onClick && typeof _this.props.onClick === 'function') {
        return _this.props.onClick(event);
      }

      return event;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.onDismiss && nextProps.isActive) {
        setTimeout(nextProps.onDismiss, nextProps.dismissAfter);
      }
    }

    /*
     * @description Dynamically get the styles for the bar.
     * @returns {object} result The style.
     */


    /*
     * @function getActionStyle
     * @description Dynamically get the styles for the action text.
     * @returns {object} result The style.
     */


    /*
     * @function handleClick
     * @description Handle click events on the
     */

  }, {
    key: 'render',
    value: function render() {
      var className = 'notification-bar';

      if (this.props.isActive) className += ' ' + this.props.activeClassName;
      if (this.props.className) className += ' ' + this.props.className;

      return _react2.default.createElement(
        'div',
        { className: className, style: this.getBarStyle() },
        _react2.default.createElement(
          'div',
          { className: 'notification-bar-wrapper', onClick: this.handleClick },
          _react2.default.createElement(
            'span',
            {
              ref: 'message',
              className: 'notification-bar-message'
            },
            this.props.message
          ),
          this.props.action !== false ? _react2.default.createElement(
            'span',
            {
              ref: 'action',
              className: 'notification-bar-action',
              style: this.getActionStyle()
            },
            this.props.action
          ) : null
        )
      );
    }
  }]);
  return Snackbar;
}(_react.Component), _class.propTypes = {
  message: _propTypes2.default.string.isRequired,
  action: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
  dismissAfter: _propTypes2.default.number,
  onDismiss: _propTypes2.default.func,
  className: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  isActive: _propTypes2.default.bool
}, _class.defaultProps = {
  isActive: false,
  dismissAfter: 2000,
  activeClassName: 'notification-bar-active'
}, _temp2);
exports.default = Snackbar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Snackbar.js
// module id = 2244
// module chunks = 0